"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTransactions = void 0;
var user_1 = require("../user");
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useTransactions = function (type, status) {
    var isAuth = (0, user_1.useIsAuthorized)();
    var _a = (0, useQuery_1.useQuery)({
        canRender: isAuth,
        path: keys_1.TRANSACTIONS,
        revalidateOnMount: true,
        payload: { type: type, status: status },
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useTransactions = useTransactions;
